import React from 'react';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import adminActions from 'src/redux/actions/adminActions';
import adminSelectors from 'src/redux/selectors/adminSelectors';
import { useNavigate } from "react-router-dom";

const UserAvatar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const admin = useSelector(adminSelectors.admin);

  const menu = (
    <Menu
      items={[
        {
          key: 'profile',
          label: <span>Profile</span>,
          icon: <UserOutlined />,
          onClick: () => navigate('/dashboard/profile')
        },
        {
          key: 'logout',
          label: <span>Log out</span>,
          icon: <LogoutOutlined />,
          danger: true,
          onClick: () => dispatch(adminActions.logout())
        }
      ]}
    />
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', marginRight: 15 }}>
          <div style={{ fontSize: 16 }}>{admin?.displayName}</div>
          <div style={{ fontSize: 12 }}>{admin?.email}</div>
        </div>
        <Avatar alt="user avatar" size={40} src={admin?.photoURL} />
      </div>
    </Dropdown>
  )
}

export default UserAvatar;